<div mat-dialog-content class="form-container" >
    <form class="form__pagoInvitacion">
        <h1>Renovación de Licencias</h1>
        <div class="infoPago">
            <p>Su licencia Nº <span class="precio">{{licencia.IDLicencia}}</span> será renovada a continuación. </p>
            <h2>El precio Total a pagar por la renovación anual es de: <span class="precio">xxxx €</span> (IVA incluido) </h2>
        </div> 
        <h3>Seleccione el método de pago:</h3>
                  <div class="metodoPago">
                    <div class="radioButton">
                      <div class="metodo-check">
                        <img src="./../../../../assets/tarjeta-de-credito.png" alt="">
                        <input
                          type="radio"
                          value="tarjeta"
                          id="tarjeta"
                          
                        />
                        <label for="tarjeta"> Tarjeta de Crédito</label>
                      </div>
                      <!-- <div class="metodo-check">
                       <img src="./../../../../assets/transferencia.png" alt="">
                        <input
                          type="radio"
                          value="transferencia"
                          id="transferencia"
                          
                        />
                        <label for="transferencia"> Transferencia Bancaria</label>
                      </div> -->
                    </div>
                  </div>
                  <div class="privacidad">
                    <input type="checkbox" id="privacidad" />
                   <label for="privacidad" id="privacidad"> He leido y acepto la <a href="https://xtensa.es/politica/"  target="_blank">Politica de Privacidad</a> y las <a href="https://xtensa.es/condiciones-de-compra/"  target="_blank">Condiciones de Compra</a></label><br><br>
                   <p id="proteccion-invitacion">
                    El responsable del tratamiento de los datos es INPRONET SOLUTIONS SL.<br> La finalidad de la recogida de datos es la de poder atender sus cuestiones, sin ceder sus datos a terceros.<br>Tiene derecho a saber qué información tenemos sobre usted, corregirla o eliminarla tal y como se explica en nuestra Política de Privacidad.</p>
                  </div>
                  <div class="boton__pasos">
                    <button >
                      Renovar y Pagar
                    </button>
                    <a href="https://frosty-roentgen.54-154-127-160.plesk.page/tpv/index.php">ddd</a>
                  </div>
    </form>
</div>
